(() => {
  if (customElements.get('sx-home-massagers')) return;
  class SxHomeMassagers extends HTMLElement {
    connectedCallback() {
      if (this._abort) this._abort.abort();
      this._abort = new AbortController();
      const options = { signal: this._abort.signal };
      this.querySelector('.sxhm__filters').hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-sxhm-filter]');
        if (!button || !this.contains(button)) return;
        this.filter(button.dataset.sxhmFilter);
      }, options);
      this.addEventListener('shopify:block:select', () => this.filter('all'), options);
      this.filter('all');
    }
    disconnectedCallback() { this._abort?.abort(); this._abort = null; }
    filter(area) {
      this.querySelectorAll('[data-sxhm-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.sxhmFilter === area)));
      let visible = 0;
      this.querySelectorAll('[data-sxhm-group]').forEach(card => {
        card.hidden = area !== 'all' && card.dataset.sxhmGroup !== area;
        if (!card.hidden) visible += 1;
      });
      const status = this.querySelector('.sxhm__count');
      status.hidden = false;
      status.textContent = `${visible} massager${visible === 1 ? '' : 's'}`;
      this.querySelector('.sxhm__empty').hidden = visible !== 0;
    }
  }
  customElements.define('sx-home-massagers', SxHomeMassagers);
})();
